module.exports = __webpack_public_path__ + "static/bottom_bar_2-6e1b5c0d6833369a039a121e517f42e7.png";